import React, { FC } from "react";
import classNames from "classnames";
import { FinancialDocumentsUpload } from "../../../documents/FinancialDocumentUpload/FinancialDocumentsUpload";
import { Button } from "../../../general/Button/Button";
import { UploadIcon } from "../../../../icons";
import {
    GridTable,
    GridTableHeader,
} from "../../../general/Tables/GridTable/GridTable";
import { UploadingDocumentPlaceholder } from "../../../documents/lib";
import { UploadReceiptRow } from "./UploadedReceiptRow";
import styles from "./Uploader.module.scss";

interface UploadReceiptsProps {
    onViewAll: () => void;
    onRemove: (item: UploadingDocumentPlaceholder) => void;
    items: UploadingDocumentPlaceholder[];
}

export const UploadReceipts: FC<UploadReceiptsProps> = ({
    onViewAll,
    onRemove,
    items,
}) => (
    <GridTable className={styles.receiptsTable}>
        <GridTableHeader>
            <div>Name</div>
            <div />
            {/* Empty div for status */}
            <div />
            {/* Empty div for actions */}
        </GridTableHeader>

        {items.map((item) => (
            <UploadReceiptRow
                item={item}
                onRemove={() => onRemove(item)}
                key={item.financialDocument?.id ?? item.fileName}
            />
        ))}

        <footer className={classNames(styles.receiptsFooter)}>
            {items.length > 0 && (
                <Button variant="tertiary" size="lg" onClick={onViewAll}>
                    View all ({items.length})
                </Button>
            )}

            <FinancialDocumentsUpload
                render={(open) => (
                    <Button variant="tertiary" onClick={open} size="lg">
                        <UploadIcon />
                        Upload another receipt
                    </Button>
                )}
            />
        </footer>
    </GridTable>
);
